
import React from "react";
import { getLabel } from "../../../data/labels";
import { getConfiguration } from '../../utils/configuration';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import ShopReceiptHeader from "./common-includes/ShopReceiptHeader";
function PickingReceipt(props){
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;

    const shopData = props.data?.shopData;
    const pickingData =  props.data?.pickingData;

    let coinsTotQta = 0;
    let coinsTotImp = 0;
    let billsTotQta = 0;
    let billsTotImp = 0;

    const additionalStyle = {
        "fontFamily" : "sans-serif",
        "fontSize" : "12px"
    };
    const thStyle = {backgroundColor:'#707070'};
    const tdStyle1 = {'textAlign':'right'};
    const tdStyle2 = {'textAlign':'right','fontWeight':'bold'};
    const tdStyle3 = {'textAlign':'right','fontWeight':'bold', 'textTransform':'uppercase'};
    const tdStyle4 = {'textAlign':'left','fontWeight':'bold'};
    const tdStyle5 = {'textAlign':'left','fontWeight':'bold','textTransform':'uppercase'};

   
    const coins = pickingData?.coins.map((c,i)=>{
        coinsTotQta+=c.numero;
        coinsTotImp+=c.totImporto;
        return  <tr key={i} >
                    <td style={tdStyle1}>{getCurrencyValue( c.importo, mult, nDec, currency)}</td>
                    <td style={tdStyle1}>{c.numero}</td>
                    <td style={tdStyle1}>{getCurrencyValue( c.totImporto, mult, nDec, currency)}</td>
                </tr>
    })

    const bills = pickingData?.bills.map((b,i)=>{
        billsTotQta+=b.numero;
        billsTotImp+=b.totImporto;
        return  <tr key={i} >
                    <td style={tdStyle1}>{getCurrencyValue( b.importo, mult, nDec, currency)}</td>
                    <td style={tdStyle1}>{b.numero}</td>
                    <td style={tdStyle1}>{getCurrencyValue( b.totImporto, mult, nDec, currency)}</td>
                </tr>
    })

    return (
        <body style={additionalStyle}>
			<ShopReceiptHeader operationTitle={getLabel('retail.picking_report_receipt')}></ShopReceiptHeader>
            <div>{getLabel('retail.date_time') + ": " + getFormattedTimestamp()}</div>
            <div>{getLabel('retail.shop_pvend') + ": " + shopData.pvend}</div>
            <div>{getLabel('retail.terminal_number') + ": " + shopData.idTag}</div>

            <br/><br/>
            <div>Dettaglio importi</div>
            <br/><br/><br/>
            <table className="width95x95 tableNoPageBreak">
                <thead>
                    <tr colSpan="3" ><th style={thStyle} >Banconote</th></tr>
                    <tr>
                        <th>Taglio</th>
                        <th>Quantit&agrave;</th>
                        <th>Importo</th>
                    </tr>
                </thead>
                <tbody>
                    {bills}
                </tbody>
                <tfoot>
                    <tr>
                        <td style={tdStyle4}>Totale Banconote</td>
                        <td style={tdStyle2}>{billsTotQta}</td>
                        <td style={tdStyle2}>{getCurrencyValue( billsTotImp, mult, nDec, currency)}</td>
                    </tr>
                </tfoot>
		    </table>
            <br/><br/>
            <table className="width95x95 tableNoPageBreak">
                <thead>
                <tr colSpan="3" ><th style={thStyle} >Monete</th></tr>
                    <tr>
                        <th>Taglio</th>
                        <th>Quantit&agrave;</th>
                        <th>Importo</th>
                    </tr>
                </thead>
                <tbody>
                    {coins}
                </tbody>
                <tfoot>
                    <tr>
                        <td style={tdStyle4}>Totale Monete</td>
                        <td style={tdStyle2}>{coinsTotQta}</td>
                        <td style={tdStyle2}>{getCurrencyValue( coinsTotImp, mult, nDec, currency)}</td>
                    </tr>
                </tfoot>
		    </table>
            <br/><br/>
            <table className="width95x95 tableNoPageBreak">
                <thead>
                <tr colSpan="3" ><th style={thStyle} ></th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={tdStyle5}>Totale nel cassetto</td>
                        <td style={tdStyle2}>{billsTotQta+coinsTotQta}</td>
                        <td style={tdStyle2}>{getCurrencyValue( billsTotImp+coinsTotImp, mult, nDec, currency)}</td>
                    </tr>
                </tbody>
               
		    </table>
		</body>
    )
}

export default PickingReceipt;